import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { showError } from '@/utils/toast';

/**
 * Komponens amely ellenőrzi, hogy az aktuális felhasználó bannolt-e.
 * Csak akkor fut, amikor az oldal megváltozik (oldal váltás).
 * Ha bannolt lett, automatikus logout-ot végez és toast üzenetet jelenít meg.
 */
const BanStatusChecker = () => {
    const { currentUser, logout } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!currentUser?.id) {
            return; // Nincs bejelentkezve
        }

        // Ellenőrizz ban státuszt oldal váltáskor
        const checkBanStatus = async () => {
            try {
                const response = await fetch('/api/current_user', {
                    credentials: 'include',
                    headers: { 'Accept': 'application/json' },
                });

                if (response.ok) {
                    const user = await response.json();

                    // Ha a user bannolt lett, végezz logout-ot
                    if (user.banned && !currentUser.banned) {
                        showError('🚫 A fiókodat bannolták. Kijelentkeztettünk.');
                        logout();
                        // Irányítsd az /login-re
                        window.location.href = '/login';
                    }
                } else if (response.status === 401) {
                    // Nem autentikált - valszínűleg már ki van jelentkezve
                    logout();
                }
            } catch (error) {
                console.error('Ban status check error:', error);
            }
        };

        checkBanStatus();
    }, [location.pathname, currentUser?.id, currentUser?.banned, logout]);
    return null;
};

export default BanStatusChecker;
